module.exports = __webpack_public_path__ + "img/drill5_7-7-2021.71e7a579.jpg";